import { NotificationService } from './notificationService';

export type PaymentReceiptEntityType = 'production' | 'sample' | 'express' | 'express_sample';

export const PAYMENT_RECEIPT_NOTIFICATION_TITLE = 'Comprobante de pago subido';

const ENTITY_LABELS: Record<PaymentReceiptEntityType, string> = {
  production: 'Producción',
  sample: 'Muestra',
  express: 'Express',
  express_sample: 'Muestra Express',
};

export interface PaymentReceiptValidationContext {
  hideFinancialFields: boolean;
  canBypassRequiredFields: boolean;
  userRole: string | null;
  cashPayment: boolean;
  paymentReceipt: string;
}

/** ¿El comprobante es obligatorio para este usuario/estado? */
export function isPaymentReceiptRequired(ctx: PaymentReceiptValidationContext): boolean {
  if (ctx.hideFinancialFields) return false;
  if (ctx.canBypassRequiredFields) return false;
  if (ctx.userRole === 'Vendedor' && ctx.cashPayment) return false;
  return true;
}

export function isPaymentReceiptValid(ctx: PaymentReceiptValidationContext): boolean {
  if (!isPaymentReceiptRequired(ctx)) return true;
  return Boolean(ctx.paymentReceipt?.trim());
}

export interface NotifyPaymentReceiptParams {
  entityType: PaymentReceiptEntityType;
  entityId: string | null;
  entityName: string;
  clientName: string;
  receiptUrl: string;
  salesperson?: string;
}

export async function notifyPaymentReceiptUploaded(params: NotifyPaymentReceiptParams): Promise<void> {
  const label = ENTITY_LABELS[params.entityType];
  const who = params.salesperson?.trim() || 'Un vendedor';
  const receiptUrl = params.receiptUrl.split('|')[0]?.trim();
  if (!receiptUrl) return;

  await NotificationService.notifyPaymentReceiptUploaded({
    entityType: params.entityType,
    entityId: params.entityId,
    entityName: params.entityName,
    clientName: params.clientName,
    receiptUrl,
    salesperson: who,
    title: `💰 ${PAYMENT_RECEIPT_NOTIFICATION_TITLE}`,
    message: `${who} subió comprobante de ${label.toLowerCase()} "${params.entityName}" (${params.clientName})`,
  });
}

export function isImageReceiptUrl(url: string): boolean {
  return /\.(jpe?g|png|gif|webp)(\?|$)/i.test(url);
}

export function isPdfReceiptUrl(url: string): boolean {
  return /\.pdf(\?|$)/i.test(url);
}
